import styled from 'styled-components';
export const InfoTextContainer = styled.div `
  margin-block-start: 8px;
`;
